import {ClockHandsIcon} from '@github-ui/custom-icons/ClockHandsIcon'
import {LinkButton} from '@primer/react'
import {ReviewState, type CompletedReview} from '@github-ui/dotcom-schema/types/pull_requests/v1/review_requests'
import type {Thread} from '@github-ui/diff-lines/conversation-types'
import {useCallback} from 'react'

import {ForYouItem} from '../shared/ForYouItem'
import {usePullRequestAnalytics} from '../../../../hooks/use-pull-request-analytics'
import {Link} from '@github-ui/react-router'
import {ViewMode} from '../../../comments/utils/view-mode'
import {routeToCommentsSection, useCurrentPathParams} from '../../data/use-comments-routing'

export function shouldShowFeedbackOpen(review: CompletedReview | undefined, reviewThreads: Thread[]): boolean {
  const hasFeedbackReview = review?.state === ReviewState.COMMENTED || review?.state === ReviewState.CHANGES_REQUESTED
  return hasFeedbackReview && reviewThreads?.some(thread => !thread.isResolved)
}

export function FeedbackOpen() {
  const {sendPullRequestAnalyticsEvent} = usePullRequestAnalytics()
  const pathParams = useCurrentPathParams()

  const onClick = useCallback(() => {
    sendPullRequestAnalyticsEvent('overview.for_you_item_action', 'OVERVIEW_FOR_YOU_ITEM', {
      item_name: 'feedback-open',
      action_name: 'view_comments',
    })
  }, [sendPullRequestAnalyticsEvent])

  return (
    <ForYouItem
      itemId="feedback-open"
      visual={{kind: 'icon', icon: ClockHandsIcon, tone: 'attention', glyphSize: 24}}
      title="Awaiting the author"
      subText="Nudge the author to address your open comments."
      actions={[
        {
          id: 'view-comments',
          content: (
            <LinkButton size="small" onClick={onClick} as={Link} to={routeToCommentsSection(pathParams, ViewMode.Mine)}>
              View your comments
            </LinkButton>
          ),
        },
      ]}
    />
  )
}
